import axios from 'axios';
import env from '../../config/env';

export const blacklistedLocationCodes = ['HK'];

export const getLocation = async () => {
  return axios.get(env.REACT_APP_LOCATION_URL);
};
